import React from 'react';
import { connect } from 'react-redux';
import loadable from '@loadable/component'

import { fetchPDP, receivePDPInfo, receiveVariantInfo, clearPDPInfo, trackPDPPageView } from '../pdp-actions';
import { fetchSlugInfo } from '../../page/page-actions'
import { PartialDataRead } from '../../caching/partial-data-store';

const PDP = loadable(() => import('./pdp'))
const PDP2 = loadable(() => import('../components-v2/index'))

/**
 * Wrapper component to add PartialDataRead cache component
 */
class PDPCacheContainer extends React.Component {
	render() {
		let { product, match } = this.props;
		let { slug, filters } = match.params;
		
		return (
			<PartialDataRead cacheKey={slug}>
	            {(cacheValue) => {
					if (!product.sku && cacheValue) {
						product = Object.assign({},product,cacheValue);
					}
					let newProps =  {...this.props, ...{ product }};
					
					if(filters === 'v2'){
						return (<PDP2 {...newProps}/>);
					}
					return (<PDP {...newProps}/>);
				}}
			</PartialDataRead>
		);
	}
}

const getDefaultPDPTitle = (product, excludeUpc=false) => {
	let { name, sku } = product;
	let upcValue = product.prdClass === 'EXT' && product.upc && !excludeUpc ? ` | UPC: ${product.upc}` : '';
	let skuValue = name.indexOf(sku) < 0 ? ` (${sku})` : '';
	return `${name}${skuValue}${upcValue}`;
}

const getProductDescription = (product, ) => {
	const { seo={}, prdClass} = product;
	const title = getDefaultPDPTitle(product, true);
	if(seo.description){
		return seo.description;
	}

	return prdClass === 'EXT' ?
	`Find all product features, specs, accessories, reviews and offers for ${title}. Save with Free Shipping when you shop online with HP.`
	: `Save with Free Shipping when you shop online with HP. Find all product features, specs, accessories, reviews and offers for ${title}.`;
}

const getEolTitle = (product) => {
	let { attributes } = product || {};
	let isPrinter = attributes && attributes.suppliesLinkUrl;
	let defaultTitle = getDefaultPDPTitle(product);
	if(!isPrinter){
		return defaultTitle
	}

	return `${defaultTitle} Ink & Toner Supplies`
}

export const getPDPTitle = (product) => {
	let { eol, seo={} } = product || {};

	if(seo.title){
		return seo.title;
	}

	if(eol){
		return getEolTitle(product);
	}

	return getDefaultPDPTitle(product);
}

const mapStateToProps = (state) => {
	const { redirects, storeDomain, router, pdp: product } = state;
	const { location } = router;
	const { pathname } = location;
	const { error, seo={} } = product; //change when backend updated
	// TODO: Check with SEO team if product.name should be used ? some slugs already contains sku number
	const title 		= getPDPTitle(product);
	const description 	= getProductDescription(product);
	const canonical 	= seo.canonical 	|| `https://${storeDomain}${pathname}`;
	const keywords		= seo.keywords;

	return {
		product,
		title,
		description,
		canonical,
		keywords,
		pageNotFound: !!error,
		redirects
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchPDP: (slug, filters) => dispatch(fetchPDP(slug, filters)),
		receivePDPInfo: product => dispatch(receivePDPInfo(product)),
		trackPDPPageView: product => dispatch(trackPDPPageView(product)),
		receiveVariantInfo: product => dispatch(receiveVariantInfo(product)),
		clearPDPInfo: () => dispatch(clearPDPInfo()),
	}
};

const loadData = (params, store, query) => {
	const { dir, slug, filters } = params;
	//TODO: this would be replaced by the AB test flag
	if(filters === 'v2'){
		const fullSlug = `${dir}/${slug}`;
		return store.dispatch(fetchSlugInfo(fullSlug, { useGraphQL: true }));
	}
	// TODO: load preload xsell on SSR (feeds above the fold carepack module) : { select: {xsell:1}}
	return store.dispatch(fetchPDP(slug, filters, query))
 		.then(result => (result.hasOwnProperty("pdpInfo") && !!result.pdpInfo.status) ? result.pdpInfo : result);
};

export default {
	component: connect(mapStateToProps, mapDispatchToProps)(PDPCacheContainer),
	loadData
}
